/*
 * The mockup's `.auth-card`: 400px wide, 32px of padding, 16px between blocks, a hairline card.
 * The brand row repeats the sidebar's mark (24px square, text colour on the surface).
 */
.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  inline-size: min(100%, 400px);
  padding: var(--space-8);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-raised);
  color: var(--text);
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  block-size: 32px;
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-semibold);
}

.logo {
  display: grid;
  place-items: center;
  flex: none;
  inline-size: 24px;
  block-size: 24px;
  border-radius: var(--radius-control);
  background: var(--text);
  color: var(--surface-raised);
}

.title {
  margin: 0;
  font-size: var(--font-size-24);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
  outline: none;
}

.subtitle {
  margin: var(--space-1) 0 0;
  color: var(--text-muted);
}

/* The credential block keeps its own rhythm; `hidden` (the code step) must still win over `flex`. */
.fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.fields[hidden] {
  display: none;
}

/* The failure sits between the fields and the action, which is where the eye
   goes back to after a refused attempt (the mockup's `.notice-danger`). */
.error {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-control);
  background-color: var(--danger-surface);
  color: var(--danger-text);
  font-size: var(--font-size-13);
}

.help {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  text-align: center;
}
